/*
 * @Description:
 * @Author: 刘宝顺
 * @Date: 2024-07-25 21:41:06
 * @LastEditTime: 2024-07-26 17:12:24
 * @LastEditors: 刘宝顺
 */
import { changeLanguage } from './i18next';
import { getURLParameters } from './tool';

/** 初始化，根据query重置语言 */
export function init(): void {
    const param = getURLParameters();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    let language = navigator.language || navigator.userLanguage;
    if (param.lang) {
        language = param.lang;
    }
    void changeLanguage(language);
}

export const transformAppType = (str) => {
    const param = getURLParameters();
    const isJETX = param.appType === 'JETX';
    if (isJETX) {
        document.title = 'JETX';
    }
    return isJETX ? str.replace('/word', '/wordJETX') : str;
};
